import React from "react";

import { ExpressionConfiguration } from "../../../rule-engine-core/Expressions/ExpressionConfiguration";
import { IntersectionRuleConfiguration } from "../../../rule-engine-core/Rule/Intersection/IntersectionRuleConfiguration";
import { IntersectionRuleColumn } from "./IntersectionRuleColumn";

import { RuleTableHeaderActionColumn, RuleTableHeaderSplit, RuleTableIndexColumn } from "../../DesignUI/CommonStyles";
import { IntersectionRuleResult } from "./IntersectionRuleResult";

interface IntersectionRuleRowProps {
    yexpression: ExpressionConfiguration;
    expressions: ExpressionConfiguration[];
    ruleDefinition: IntersectionRuleConfiguration;
    y: number;
}

export const IntersectionRuleRow = (props: IntersectionRuleRowProps) => {
    const { expressions, ruleDefinition, yexpression, y } = props;

    return (
        <>
            <RuleTableIndexColumn
                x={0}
                y={y + 2}
            >
                {y + 1}
            </RuleTableIndexColumn>

            <IntersectionRuleColumn
                ruleDefinition={ruleDefinition}
                expression={yexpression}
                direction={"y"}
                index={props.y}
            />

            <RuleTableHeaderSplit
                width={1}
                height={44}
                x={2}
                y={y + 2}
            />

            {expressions.map((exp, index) => (
                <IntersectionRuleResult
                    ruleDefinition={ruleDefinition}
                    key={exp._id}
                    resultCell={ruleDefinition.findResultCellByXY(exp._id, yexpression._id)!}
                    x={index}
                    y={y}
                />
            ))}

            <RuleTableHeaderActionColumn />
        </>
    );
};
